import { Component, OnInit, AfterViewInit } from '@angular/core';
import {IUserproviderInterface} from '../../core/interfaces/userprovider.interface';
import {T2ThemeService} from '../../trip2-theme/t2-theme.service';
import {IUserInterface} from '../../core/interfaces/user.interface';
import {ComunicationDashboard} from './comunication-dashboard';

@Component({
  selector: 'app-dashboard-providers',
  templateUrl: './dashboard-providers.component.html',
  styleUrls: ['./dashboard-providers.component.scss']
})
export class DashboardProvidersComponent implements OnInit {

  public selectProviderid: number;
  public userProviders: IUserproviderInterface[];
  constructor(
    private _serviceUser: T2ThemeService,
    private _comunication: ComunicationDashboard
  ) {
    this.getUser();
  }

  ngOnInit() {
  }

  /**@name getUser
   * @description Trae el usuario actual con sus Providers
   */
  getUser() {
    this._serviceUser.getUserProfile().subscribe(
      (user: IUserInterface) => {
        if (user.usertypeid === 2) {
          this.selectProviderid = user.defaultproviderid;
          this.userProviders = user.userproviders;
          this._comunication.enterId.next(this.selectProviderid);
        }
      },
      error => {}
    );
  }

  onChangeProviderId(id: number) {
    this._comunication.enterId.next(id);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers/dashboard-providers.component.ts